import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=1630a462&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=1630a462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630a462",
  null
  
)

export default component.exports